var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluedot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_408",
    "data-name": "Ellipse 408",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    fill: "#1c75bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluedot);
export default __webpack_public_path__ + "static/media/bluedot.3580ad39d7792ad838142093920275e4.svg";
export { ForwardRef as ReactComponent };